import * as types from "../actions/actionTypes";

// state = [] : Start out with no accounts
export default function accountOverview(state = [], action) {
  switch (action.type) {
    case types.GET_ACCOUNT_OVERVIEW:
      return action.account_overview;

    default:
      return state;
  }
}
